import { PropsWithChildren } from 'react';

import { Props } from './types';
import { Loader, StyledButton } from './styled';

const Button = ({
  children,
  withIcon,
  Icon,
  variant = 'Default',
  onlyIcon = false,
  hasHover = true,
  size = 'large',
  loading,
  outline,
  type = 'button',
  ...rest
}: PropsWithChildren<Props>) => {
  const normalButtonContent = typeof children === 'string';

  return (
    <StyledButton
      variant={variant}
      isSecondaryColor={variant === 'Secondary'}
      hasHover={hasHover}
      outline={outline}
      size={size}
      type={type}
      borderRadius={8}
      {...rest}
    >
      {loading && !outline ? <Loader /> : null}
      {normalButtonContent ? (
        <>
          {(onlyIcon && withIcon) || !children ? null : <span>{children}</span>}

          {withIcon ? Icon : null}
        </>
      ) : (
        children
      )}
    </StyledButton>
  );
};

export default Button;
